



















import PageMixin from '@/mixins/page-mixin';
import CronjobServices from '@/services/cronjob';
import { mixins } from 'vue-class-component';
import { Vue, Component } from 'vue-property-decorator';
import JobFilter from '../../components/job-filter.vue';
import JobList from '../../components/job-list.vue';
@Component({
  components: { JobFilter, JobList }
})
export default class Job1 extends mixins(PageMixin)  {
  bread = [{ name: '作业调度管理' }, { name: '系统运维作业' }];
  jobSrv = new CronjobServices();

  created() {
    this.getList();
  }

  list: any[] = [];
  async getList(params?: object) {
    let param: any = { jobGroupName_eq: 'sys' };
    if (params) {
      param = { ...param, ...params };
    }
    this.loading = true;
    let res = await this.jobSrv.getPage({ ...param, page: this.page, limit: this.limit });
    this.list = res.records;
    this.total = res.total;
    this.loading = false;
  }
}
